<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.content-main-box {
  height: calc(100vh - 60px - 35px - 66px);
}
.el-table {
  border-bottom: 1px solid #D9D9D9;
}
</style>
<template>
  <div class="content">
    <!-- start of search -->
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">功能编码</div>
          <el-input v-model="page.functionCode" class="ipt-sty" placeholder="请输入功能编码"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">功能名称</div>
          <el-input v-model="page.functionName" class="ipt-sty" placeholder="请输入功能名称"></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- end of search -->

    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">新增功能</el-button>
    </div> -->
    <div class="back-color-fff content-main-box">
      <div class="button-area" v-if="addConfig.length && addConfig[0].parameterValue == '开'">
        <el-button size="mini" type="info" @click="addData">新增功能</el-button>
      </div>

      <el-table :data="tableData" stripe border style="width: 100%;" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="functionCode" label="功能编码" width="160px" show-overflow-tooltip header-align="center" align="left" fixed="left">
          <template slot-scope="scope">{{ scope.row.functionCode }}</template>
        </el-table-column>
        <el-table-column prop="functionName" label="功能名称" width="160px" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.functionName }}</template>
        </el-table-column>
        <el-table-column prop="functionDesc" label="功能说明" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.functionDesc || '-' }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="220px" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="configTenant(scope.row)">去配置 ｜</a>
            <a class="txt-color" @click="editVersion(scope.row)">功能说明</a>
            <a class="txt-color" @click="editData(scope.row)" v-if="editConfig.length != 0 && editConfig[0].parameterValue == '开'"> ｜编辑</a>
            <a class="txt-color" @click="delData(scope.row.guid)" v-if="delConfig.length != 0 && delConfig[0].parameterValue == '开'"> ｜删除</a>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="page.pageIndex"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
      </el-pagination>

    </div>
    
    <!-- start of dialog-功能说明 -->
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="560px">
        <el-input type="textarea"  resize="none" :rows="8" :maxlength="100" placeholder="用于理解该功能的用途" v-model="functionDesc"> </el-input>
        <div class="dialog-footer" style="padding-top: 20px;text-align: right;">
          <el-button size="mini" plain @click="dialogVisible = false">取 消</el-button>
          <el-button v-if="!this.guid" size="mini" type="info" @click="addReqVersion"
            v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
          <el-button v-else size="mini" type="info" @click="updateReqVersion"
            v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
        </div>
    </el-dialog>
    <!-- end of dialog-功能说明 -->

    <!-- start of dialog-新增|编辑 -->
    <el-dialog :title="isAdd ? '新增功能' : '编辑功能'" :visible.sync="editDialog" width="500px">
      <el-form
        ref="formData"
        label-width="80px" 
        :model="formData"
        :rules="formRules"
      >
        <!-- 功能编码 -->
        <el-form-item label="功能编码" prop="functionCode">
          <el-input size="small" :maxlength="10" oninput="value=value.replace(/[^\a-\z\A-\Z]/g, '')" v-model="formData.functionCode" placeholder="请填写功能编码" clearable />
        </el-form-item>
        <!-- 功能名称 -->
        <el-form-item label="功能名称" prop="functionName" style="margin-bottom:0;">
          <el-input size="small" :maxlength="20" v-model="formData.functionName" placeholder="请填写功能名称" clearable />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="editDialog = false">取 消</el-button>
        <el-button size="mini" type="info" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-新增|编辑 -->

  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  name: 'h5ConfigList',
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        functionCode: '',
        functionName: '',
      },
      functionCode: '',
      functionName: '',
      functionDesc: '',
      guid: '',
      height: window.innerHeight - 250,
      right: 'right',
      tableData: [],
      dialogVisible: false,

      editDialog: false,
      isAdd: true, // 是否是新增
      formData: {
        guid: '',
        functionCode: '', // 功能编码
        functionName: '' // 功能名称
      },
      formRules: {
        functionCode: [
          { required: true, message: '功能编码必填', trigger: 'blur' },
        ],
        functionName: [
          { required: true, message: '功能名称必填', trigger: 'blur' },
        ]
      },
      
      addConfig:[],
      delConfig:[],
      editConfig:[],
    };
  },
  created() {
    if (sessionStorage.functionPageIndex) {
      this.page.pageIndex = Number(sessionStorage.functionPageIndex);
    }
    if (sessionStorage.functionPageSzie) {
      this.page.pageSize = Number(sessionStorage.functionPageSzie);
    }

    this.getList();
    this.getConfig()
  },
  watch: {},
  methods: {
    /**
     * 获取系统里字段配置
     */
    getConfig() {
      let that = this;
      that.api.get(
        `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=GNPZZDCZKG`,
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = resp.data.data;
          this.addConfig = data.filter(item=>item.name == "新增功能");
          this.delConfig = data.filter(item=>item.name == "删除功能");
          this.editConfig = data.filter(item=>item.name == "编辑功能");
        }
      });
    },
    /**
     * 添加
     */
    addData() {
      this.isAdd = true;
      this.editDialog = true;
      this.formData = {
        guid: '',
        functionCode: '', // 功能编码
        functionName: '' // 功能名称
      }
      let that = this;
      this.$nextTick(() => {
        that.$refs['formData'].clearValidate();
      })
    },
    /**
     * 编辑
     */
    editData(item) {
      this.isAdd = false;
      this.editDialog = true;
      this.formData = JSON.parse(JSON.stringify(item));
      let that = this;
      this.$nextTick(() => {
        that.$refs['formData'].clearValidate();
      })
    },
    /**
     * 提交
     */
    submitForm() {
      let that = this;
      that.$refs['formData'].validate((valid) => {
        if (valid) {
          // 新增
          if(that.isAdd) {
            that.api.postJson(`/${serverConfig.msConfigureService}/function/add`, that.formData).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                that.editDialog = false;
                that.$message.success('添加成功');
                that.getList();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          }
          // 修改
          if(!that.isAdd) {
            that.api.put(`/${serverConfig.msConfigureService}/function/update`, that.formData).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                that.editDialog = false;
                that.$message.success('编辑成功');
                that.getList();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    delData(guid) {
      let that = this;
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        that.api.postJson(`/${serverConfig.msConfigureService}/function/delete`, [guid]).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            that.$message.success('删除成功');
            that.getList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
    },
    configTenant(detail) {
      let query = {
        functionGuid: detail.guid,
        functionCode: detail.functionCode,
      };
      let path = '';
      if (detail.functionCode == 'WJDC') {
        path = '/questionnaireList';
      } else {
        path = '/h5ConfigTenantList';
      }
      if (this.$route.query.productGuid) {
        query.productGuid = this.$route.query.productGuid;
      }
      localStorage.setItem('threeLevels', detail.functionName);
      sessionStorage.setItem('functionPageIndex', this.page.pageIndex);
      sessionStorage.setItem('functionPageSzie', this.page.pageSize)
      
      // 下级页需要重新回复默认值
      if (sessionStorage.listPageIndex2) {
        sessionStorage.setItem('listPageIndex2', 1);
      }
      if (sessionStorage.listPageSize2) {
        sessionStorage.setItem('listPageSize2', 50);
      }
      
      this.$router.push({
        path,
        query,
      });
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.page.pageIndex = 1;
      self.api.postJson(`/${serverConfig.msConfigureService}/function/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        functionCode: '',
        functionName: '',
      };
      this.getList();
    },
    editVersion(detail) {
      this.textTitle = '编辑功能说明';
      this.dialogVisible = true;
      this.functionDesc = detail.functionDesc;
      this.functionName = detail.functionName;
      this.functionCode = detail.functionCode;
      this.guid = detail.guid;
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msConfigureService}/function/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addReqVersion() {
      var self = this;
      if (!this.functionCode) {
        self.$message.error('请输入功能编码');
        return;
      }
      if (!this.functionName) {
        self.$message.error('请输入功能名称');
        return;
      }
      if (!this.functionDesc) {
        self.$message.error('请输入功能说明');
        return;
      }
      var req = {
        functionCode: this.functionCode,
        functionName: this.functionName,
        functionDesc: this.functionDesc,
      };
      self.api.postJson(`/${serverConfig.msConfigureService}/function/add`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.functionCode) {
        self.$message.error('请输入功能编码');
        return;
      }
      if (!this.functionName) {
        self.$message.error('请输入功能名称');
        return;
      }
      if (!this.functionDesc) {
        self.$message.error('请输入功能说明');
        return;
      }
      var req = {
        functionCode: this.functionCode,
        functionName: this.functionName,
        functionDesc: this.functionDesc,
        guid: this.guid,
      };
      self.api.put(`/${serverConfig.msConfigureService}/function/update`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val || 1;
      this.getList();
    },
  },
};
</script> 
<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/deep/ .el-dialog__header{
  text-align: left;
  border-bottom: 1px solid #D9D9D9 ;
  padding:  20px;
  padding-bottom: 15px;
}
/deep/ .el-dialog__body{
  padding:20px;
}
</style>